function buildCollectionRoutes({
  routes,
  onEnterMyMusic,
  onEnterCollection,
  createConditionalComponent,
  AsyncDomain,
}) {
  return routes.concat([
    {
      path: 'my-music',
      onEnter: onEnterMyMusic,
      indexRoute: {
        props: {
          domain: 'collection',
          component: 'MyMusicContainer',
          key: 'MyMusic',
        },
        component: AsyncDomain,
      },
      childRoutes: [
        {
          path: ':filter',
          onEnter: onEnterMyMusic,
          getComponent(location, cb) {
            cb(
              null,
              createConditionalComponent({
                domain: 'collection',
                component: 'MyMusicContainer',
                key: 'MyMusicFilter',
              }),
            );
          },
        },
      ],
    },
    {
      path: 'my-music/artists/:artistId',
      onEnter: onEnterMyMusic,
      props: {
        domain: 'collection',
        component: 'MyMusicContainer',
        key: 'MyMusicArtistCollection',
      },
      component: AsyncDomain,
    },
    {
      path: 'collection(/:filter)',
      onEnter: onEnterCollection,
      indexRoute: {
        props: {
          domain: 'collection',
          component: 'MyMusicContainer',
          key: 'MyMusic',
        },
        component: AsyncDomain,
      },
    },
    {
      path: 'collection/artists/:artistId',
      onEnter: onEnterCollection,
      props: {
        domain: 'collection',
        component: 'MyMusicContainer',
        key: 'MyMusicArtistCollection',
      },
      component: AsyncDomain,
    },
  ]);
}

export default {
  buildCollectionRoutes,
};
